// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import type {
  AdminActivityActionsData,
  AdminActivityActionsResponses,
  AdminActivityAnalyticsData,
  AdminActivityAnalyticsErrors,
  AdminActivityAnalyticsResponses,
  AdminBlockUserData,
  AdminBlockUserErrors,
  AdminBlockUserResponses,
  AdminDeleteUserData,
  AdminDeleteUserErrors,
  AdminDeleteUserResponses,
  AdminGetUserData,
  AdminGetUserErrors,
  AdminGetUserResponses,
  AdminInviteUserData,
  AdminInviteUserErrors,
  AdminInviteUserResponses,
  AdminListActivityData,
  AdminListActivityErrors,
  AdminListActivityResponses,
  AdminListUsersData,
  AdminListUsersResponses,
  AdminUnblockUserData,
  AdminUnblockUserErrors,
  AdminUnblockUserResponses,
  AdminUpdateUserData,
  AdminUpdateUserErrors,
  AdminUpdateUserResponses,
  ChangePasswordData,
  ChangePasswordErrors,
  ChangePasswordResponses,
  ComposerAddToLibraryData,
  ComposerAddToLibraryErrors,
  ComposerAddToLibraryResponses,
  ComposerAskData,
  ComposerAskErrors,
  ComposerAskResponses,
  ComposerComposeData,
  ComposerComposeErrors,
  ComposerComposeResponses,
  ComposerConfirmDeckData,
  ComposerConfirmDeckErrors,
  ComposerConfirmDeckResponses,
  ComposerConfirmEscalationData,
  ComposerConfirmEscalationErrors,
  ComposerConfirmEscalationResponses,
  ComposerConfirmFormatsData,
  ComposerConfirmFormatsErrors,
  ComposerConfirmFormatsResponses,
  ComposerConfirmPagesData,
  ComposerConfirmPagesErrors,
  ComposerConfirmPagesResponses,
  ComposerConfirmRevisionData,
  ComposerConfirmRevisionErrors,
  ComposerConfirmRevisionResponses,
  ComposerDeleteAssetData,
  ComposerDeleteAssetErrors,
  ComposerDeleteAssetResponses,
  ComposerDownloadData,
  ComposerDownloadErrors,
  ComposerDownloadResponses,
  ComposerDownloadStringsData,
  ComposerDownloadStringsErrors,
  ComposerDownloadStringsResponses,
  ComposerFetchAssetData,
  ComposerFetchAssetErrors,
  ComposerFetchAssetResponses,
  ComposerGetArtifactPreviewData,
  ComposerGetArtifactPreviewErrors,
  ComposerGetArtifactPreviewPageData,
  ComposerGetArtifactPreviewPageErrors,
  ComposerGetArtifactPreviewPageResponses,
  ComposerGetArtifactPreviewResponses,
  ComposerGetAssetFileData,
  ComposerGetAssetFileErrors,
  ComposerGetAssetFileResponses,
  ComposerGetAssetThumbnailData,
  ComposerGetAssetThumbnailErrors,
  ComposerGetAssetThumbnailResponses,
  ComposerGetDocumentData,
  ComposerGetDocumentErrors,
  ComposerGetDocumentResponses,
  ComposerGetPageThumbnailData,
  ComposerGetPageThumbnailErrors,
  ComposerGetPageThumbnailResponses,
  ComposerGetSocialAdRenderData,
  ComposerGetSocialAdRenderErrors,
  ComposerGetSocialAdRenderResponses,
  ComposerGetTurnData,
  ComposerGetTurnErrors,
  ComposerGetTurnResponses,
  ComposerIntakeData,
  ComposerIntakeErrors,
  ComposerIntakeResponses,
  ComposerListAssetsData,
  ComposerListAssetsResponses,
  ComposerListEscalationsData,
  ComposerListEscalationsResponses,
  ComposerListLibraryQueueData,
  ComposerListLibraryQueueResponses,
  ComposerListRulesData,
  ComposerListRulesResponses,
  ComposerListTurnsData,
  ComposerListTurnsErrors,
  ComposerListTurnsResponses,
  ComposerLocalizePdfData,
  ComposerLocalizePdfErrors,
  ComposerLocalizePdfResponses,
  ComposerPreviewTurnRemovalData,
  ComposerPreviewTurnRemovalErrors,
  ComposerPreviewTurnRemovalResponses,
  ComposerRefineData,
  ComposerRefineErrors,
  ComposerRefineResponses,
  ComposerRemoveTurnData,
  ComposerRemoveTurnErrors,
  ComposerRemoveTurnResponses,
  ComposerRenameTurnData,
  ComposerRenameTurnErrors,
  ComposerRenameTurnResponses,
  ComposerTranslationStatusData,
  ComposerTranslationStatusResponses,
  ComposerUploadAssetsData,
  ComposerUploadAssetsErrors,
  ComposerUploadAssetsResponses,
  GetActivityData,
  GetActivityResponses,
  GetHealthData,
  GetHealthResponses,
  GetMeData,
  GetMeDetailData,
  GetMeDetailResponses,
  GetMeResponses,
  LoginData,
  LoginErrors,
  LoginResponses,
  LogoutData,
  LogoutResponses,
  SignupData,
  SignupErrors,
  SignupResponses,
  UpdateProfileData,
  UpdateProfileErrors,
  UpdateProfileResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Composer List Assets
 *
 * Scan the inbox and describe everything available to compose from.
 */
export const composerListAssets = <ThrowOnError extends boolean = false>(
  options?: Options<ComposerListAssetsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ComposerListAssetsResponses, unknown, ThrowOnError>({
    url: "/composer/assets",
    ...options,
  });

/**
 * Composer Upload Assets
 *
 * Upload files into the same inbox the user can also drop files into.
 */
export const composerUploadAssets = <ThrowOnError extends boolean = false>(
  options: Options<ComposerUploadAssetsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ComposerUploadAssetsResponses,
    ComposerUploadAssetsErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/composer/assets/upload",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Composer Fetch Asset
 *
 * Add a source file to the library from a public link.
 *
 * The material this works on is large and already published — the case
 * studies are 90MB and 40MB on livingplaces.velux.com — so fetching beats
 * uploading: one request, no browser carrying a file across a hosted edge,
 * and it is closer to what the real product does against a DAM.
 */
export const composerFetchAsset = <ThrowOnError extends boolean = false>(
  options: Options<ComposerFetchAssetData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ComposerFetchAssetResponses,
    ComposerFetchAssetErrors,
    ThrowOnError
  >({
    url: "/composer/assets/fetch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Composer Delete Asset
 *
 * Remove one supplied file from the inbox and rescan.
 */
export const composerDeleteAsset = <ThrowOnError extends boolean = false>(
  options: Options<ComposerDeleteAssetData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ComposerDeleteAssetResponses,
    ComposerDeleteAssetErrors,
    ThrowOnError
  >({ url: "/composer/assets/{asset_id}", ...options });

/**
 * Composer Get Asset File
 *
 * Serve a supplied file, so the client never builds a path itself.
 */
export const composerGetAssetFile = <ThrowOnError extends boolean = false>(
  options: Options<ComposerGetAssetFileData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ComposerGetAssetFileResponses,
    ComposerGetAssetFileErrors,
    ThrowOnError
  >({ url: "/composer/assets/{asset_id}/file", ...options });

/**
 * Composer Get Asset Thumbnail
 *
 * Serve the cached preview thumbnail for a supplied file.
 */
export const composerGetAssetThumbnail = <ThrowOnError extends boolean = false>(
  options: Options<ComposerGetAssetThumbnailData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ComposerGetAssetThumbnailResponses,
    ComposerGetAssetThumbnailErrors,
    ThrowOnError
  >({ url: "/composer/assets/{asset_id}/thumbnail", ...options });

/**
 * Composer Ask
 *
 * Answer "what asset are you looking for?" with a decided outcome.
 *
 * The requestor never picks an edit type. This searches the asset database,
 * works out which of the four outcomes is honestly possible, and — where the
 * answer is a deck — builds it right away. Where it needs a human (which
 * pages to keep, or permission to brief Strategic Comms) it says so and waits.
 *
 * `corrections` carries any control the requestor set by hand after seeing how
 * their words were read; those win over the parse. `previous_turn_id` carries
 * the request this one follows, so "the same in French" knows what "the same"
 * is.
 */
export const composerAsk = <ThrowOnError extends boolean = false>(
  options: Options<ComposerAskData, ThrowOnError>,
) =>
  (options.client ?? client).post<ComposerAskResponses, ComposerAskErrors, ThrowOnError>({
    url: "/composer/ask",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Composer Preview Turn Removal
 *
 * What would be lost by removing this request — asked before it is.
 *
 * A request that is already gone has nothing to lose, which is an answer
 * rather than an error: the rail can hold a row for a turn removed in another
 * tab, and 404ing that put a failure on screen where "nothing will be lost"
 * was the truth.
 */
export const composerPreviewTurnRemoval = <ThrowOnError extends boolean = false>(
  options: Options<ComposerPreviewTurnRemovalData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ComposerPreviewTurnRemovalResponses,
    ComposerPreviewTurnRemovalErrors,
    ThrowOnError
  >({ url: "/composer/turns/{turn_id}/removal", ...options });

/**
 * Composer Remove Turn
 *
 * Remove one request from the history, and the files only it holds.
 *
 * A generated file that was never downloaded and never put forward for the
 * library exists in exactly one place, and this is the thing that deletes it —
 * so it deletes it rather than orphaning a file nothing can reach. One already
 * queued for the library is left alone: it belongs to the library now, not to
 * the request that happened to produce it.
 */
export const composerRemoveTurn = <ThrowOnError extends boolean = false>(
  options: Options<ComposerRemoveTurnData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ComposerRemoveTurnResponses,
    ComposerRemoveTurnErrors,
    ThrowOnError
  >({ url: "/composer/turns/{turn_id}", ...options });

/**
 * Composer Get Turn
 *
 * Re-read one remembered turn.
 */
export const composerGetTurn = <ThrowOnError extends boolean = false>(
  options: Options<ComposerGetTurnData, ThrowOnError>,
) =>
  (options.client ?? client).get<ComposerGetTurnResponses, ComposerGetTurnErrors, ThrowOnError>({
    url: "/composer/turns/{turn_id}",
    ...options,
  });

/**
 * Composer Rename Turn
 *
 * Name one conversation in the history, or clear the name again.
 *
 * The rail derives its label from the matched asset, which reads well until a
 * market runs three rounds off one asset and needs to tell them apart. An
 * empty or whitespace-only name clears the chosen one and the derived label
 * comes back, so undo needs no route of its own.
 *
 * Unlike removal — where a turn that is already gone is the outcome the caller
 * asked for — a name has nowhere to land if the turn does not exist, so this
 * 404s rather than reporting a success it did not achieve.
 */
export const composerRenameTurn = <ThrowOnError extends boolean = false>(
  options: Options<ComposerRenameTurnData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    ComposerRenameTurnResponses,
    ComposerRenameTurnErrors,
    ThrowOnError
  >({
    url: "/composer/turns/{turn_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Composer Get Artifact Preview
 *
 * Page images for a generated artifact, rendering them on first ask.
 *
 * Reviewing a deck should not require downloading it and opening PowerPoint —
 * that is the moment the tool stops being self-serve.
 */
export const composerGetArtifactPreview = <ThrowOnError extends boolean = false>(
  options: Options<ComposerGetArtifactPreviewData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ComposerGetArtifactPreviewResponses,
    ComposerGetArtifactPreviewErrors,
    ThrowOnError
  >({ url: "/composer/artifacts/{artifact_id}/preview", ...options });

/**
 * Composer Get Artifact Preview Page
 *
 * One rendered page of a generated artifact.
 */
export const composerGetArtifactPreviewPage = <ThrowOnError extends boolean = false>(
  options: Options<ComposerGetArtifactPreviewPageData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ComposerGetArtifactPreviewPageResponses,
    ComposerGetArtifactPreviewPageErrors,
    ThrowOnError
  >({ url: "/composer/artifacts/{artifact_id}/preview/{page}", ...options });

/**
 * Composer List Turns
 *
 * The most recent requests, newest first, one entry per distinct request.
 *
 * Turns were already persisted so that a page pick or a build confirmation
 * could find them later. Listing them means a closed tab stops losing the work
 * as well.
 *
 * Asking the same thing twice replaces the older entry rather than adding a
 * second: history is meant to answer "what have I asked for?", and ten copies
 * of one sentence answers nothing. The turns themselves are left alone — a
 * turn still waiting on a confirmation must stay resolvable by its id, so this
 * collapses the *view*, not the store.
 */
export const composerListTurns = <ThrowOnError extends boolean = false>(
  options?: Options<ComposerListTurnsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ComposerListTurnsResponses,
    ComposerListTurnsErrors,
    ThrowOnError
  >({ url: "/composer/turns", ...options });

/**
 * Composer Confirm Pages
 *
 * Complete a `propose_pdf_pages` turn with the pages the requestor chose.
 */
export const composerConfirmPages = <ThrowOnError extends boolean = false>(
  options: Options<ComposerConfirmPagesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ComposerConfirmPagesResponses,
    ComposerConfirmPagesErrors,
    ThrowOnError
  >({
    url: "/composer/turns/{turn_id}/pages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Composer Confirm Deck
 *
 * Build the deck the requestor just approved.
 *
 * Everything expensive lives here rather than in `/ask`: the copywriting, the
 * translation and the PowerPoint write. Until this is called, the proposal has
 * cost a search.
 */
export const composerConfirmDeck = <ThrowOnError extends boolean = false>(
  options: Options<ComposerConfirmDeckData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ComposerConfirmDeckResponses,
    ComposerConfirmDeckErrors,
    ThrowOnError
  >({ url: "/composer/turns/{turn_id}/confirm-deck", ...options });

/**
 * Composer Confirm Revision
 *
 * Apply the slide edits the requestor just approved, and rebuild from them.
 *
 * The deck is re-rendered from the slides the original run *stored*, not
 * recomposed: no narrative pass, no copywriter, no second search. That is the
 * whole promise of this route — a market that asks for slide 4 to go gets the
 * other fourteen slides back word for word.
 *
 * The original artifact is left where it is. A revision is a new file with a
 * new id, because "put slide 4 back" is a thing a market says.
 */
export const composerConfirmRevision = <ThrowOnError extends boolean = false>(
  options: Options<ComposerConfirmRevisionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ComposerConfirmRevisionResponses,
    ComposerConfirmRevisionErrors,
    ThrowOnError
  >({ url: "/composer/turns/{turn_id}/confirm-revision", ...options });

/**
 * Composer Confirm Formats
 *
 * Render the approved ad in the formats the requestor chose.
 *
 * Everything expensive lives here rather than in `/ask`: the proposal cost a
 * pool lookup and a short copy call, and the pixels are only written once
 * somebody has said which platforms this is actually for.
 *
 * The creative route can change here, and so can the photograph. The plan
 * proposes one route of three and offers the runners-up photographs beside
 * it, so `route_key` picks a different idea and `image_asset_id` a different
 * picture for it — in that order, because a route brings its own photograph
 * and the explicit one has to win. Both are validated rather than trusted:
 * this is the request that decides which words go over which photograph.
 */
export const composerConfirmFormats = <ThrowOnError extends boolean = false>(
  options: Options<ComposerConfirmFormatsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ComposerConfirmFormatsResponses,
    ComposerConfirmFormatsErrors,
    ThrowOnError
  >({
    url: "/composer/turns/{turn_id}/confirm-formats",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Composer Get Social Ad Render
 *
 * Serve one rendered ad — inline for the preview grid, attached to download.
 *
 * Gated on the artifact registry like every other download route. It used to
 * read straight off disk, which meant removing a conversation — the one thing
 * that is supposed to delete what it generated — left every ad still
 * fetchable by anyone holding a preview link, and the docstring's claim that
 * a stale URL cannot serve someone else's file was not true of this one.
 */
export const composerGetSocialAdRender = <ThrowOnError extends boolean = false>(
  options: Options<ComposerGetSocialAdRenderData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ComposerGetSocialAdRenderResponses,
    ComposerGetSocialAdRenderErrors,
    ThrowOnError
  >({ url: "/composer/artifacts/{artifact_id}/social/{format_key}", ...options });

/**
 * Composer Confirm Escalation
 *
 * Send — or decline to send — the drafted brief to Strategic Comms.
 *
 * Nothing reaches Strategic Comms without this step. Declining keeps the
 * draft so the requestor can reword the ask and try again.
 */
export const composerConfirmEscalation = <ThrowOnError extends boolean = false>(
  options: Options<ComposerConfirmEscalationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ComposerConfirmEscalationResponses,
    ComposerConfirmEscalationErrors,
    ThrowOnError
  >({
    url: "/composer/turns/{turn_id}/confirm-escalation",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Composer Intake
 *
 * Parse a free-text request into pre-selected controls with evidence.
 */
export const composerIntake = <ThrowOnError extends boolean = false>(
  options: Options<ComposerIntakeData, ThrowOnError>,
) =>
  (options.client ?? client).post<ComposerIntakeResponses, ComposerIntakeErrors, ThrowOnError>({
    url: "/composer/intake",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Composer Compose
 *
 * Mode 1 — rework the supplied materials into a new translated deck.
 */
export const composerCompose = <ThrowOnError extends boolean = false>(
  options: Options<ComposerComposeData, ThrowOnError>,
) =>
  (options.client ?? client).post<ComposerComposeResponses, ComposerComposeErrors, ThrowOnError>({
    url: "/composer/compose",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Composer Refine
 *
 * Apply one more instruction to a previous artifact and regenerate it.
 *
 * The stored request is replayed with the instruction folded into its
 * controls, so switching language or audience reworks the *same* supplied
 * material rather than starting over.
 */
export const composerRefine = <ThrowOnError extends boolean = false>(
  options: Options<ComposerRefineData, ThrowOnError>,
) =>
  (options.client ?? client).post<ComposerRefineResponses, ComposerRefineErrors, ThrowOnError>({
    url: "/composer/refine",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Composer Get Document
 *
 * A supplied PDF as a pickable page grid.
 */
export const composerGetDocument = <ThrowOnError extends boolean = false>(
  options: Options<ComposerGetDocumentData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ComposerGetDocumentResponses,
    ComposerGetDocumentErrors,
    ThrowOnError
  >({ url: "/composer/documents/{asset_id}", ...options });

/**
 * Composer Get Page Thumbnail
 *
 * A cached PNG thumbnail of one page, for the picker grid.
 */
export const composerGetPageThumbnail = <ThrowOnError extends boolean = false>(
  options: Options<ComposerGetPageThumbnailData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ComposerGetPageThumbnailResponses,
    ComposerGetPageThumbnailErrors,
    ThrowOnError
  >({ url: "/composer/documents/{asset_id}/pages/{page}/thumbnail", ...options });

/**
 * Composer Localize Pdf
 *
 * Mode 2 — keep the chosen pages and translate their text in place.
 */
export const composerLocalizePdf = <ThrowOnError extends boolean = false>(
  options: Options<ComposerLocalizePdfData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ComposerLocalizePdfResponses,
    ComposerLocalizePdfErrors,
    ThrowOnError
  >({
    url: "/composer/documents/{asset_id}/localize",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Composer Download
 *
 * Download a generated artifact by id.
 */
export const composerDownload = <ThrowOnError extends boolean = false>(
  options: Options<ComposerDownloadData, ThrowOnError>,
) =>
  (options.client ?? client).get<ComposerDownloadResponses, ComposerDownloadErrors, ThrowOnError>({
    url: "/composer/artifacts/{artifact_id}/download",
    ...options,
  });

/**
 * Composer Download Strings
 *
 * Download a run's strings as XLIFF, for a translation vendor to import.
 *
 * Serves the sibling of the artifact itself: the same run's copy in the
 * format Trados, memoQ and Phrase read, so a document that has to be
 * localized from its InDesign source does not have to be retyped first.
 */
export const composerDownloadStrings = <ThrowOnError extends boolean = false>(
  options: Options<ComposerDownloadStringsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ComposerDownloadStringsResponses,
    ComposerDownloadStringsErrors,
    ThrowOnError
  >({ url: "/composer/artifacts/{artifact_id}/strings", ...options });

/**
 * Composer List Rules
 *
 * The encoded guardrails — the durable artifact behind the report.
 */
export const composerListRules = <ThrowOnError extends boolean = false>(
  options?: Options<ComposerListRulesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ComposerListRulesResponses, unknown, ThrowOnError>({
    url: "/composer/rules",
    ...options,
  });

/**
 * Composer Add To Library
 *
 * Offer a generated file back to the asset library.
 *
 * The market that generated it has already decided it is worth having; what
 * it cannot decide alone is whether it counts as approved brand material. So
 * this queues it for Strategic Comms rather than making it searchable, and
 * says plainly which of the two happened.
 */
export const composerAddToLibrary = <ThrowOnError extends boolean = false>(
  options: Options<ComposerAddToLibraryData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ComposerAddToLibraryResponses,
    ComposerAddToLibraryErrors,
    ThrowOnError
  >({ url: "/composer/artifacts/{artifact_id}/add-to-library", ...options });

/**
 * Composer List Library Queue
 *
 * Everything markets have offered back to the library, newest first.
 */
export const composerListLibraryQueue = <ThrowOnError extends boolean = false>(
  options?: Options<ComposerListLibraryQueueData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ComposerListLibraryQueueResponses, unknown, ThrowOnError>({
    url: "/composer/library",
    ...options,
  });

/**
 * Composer List Escalations
 *
 * Every tier-3 brief drafted for the Strategic Comms team.
 */
export const composerListEscalations = <ThrowOnError extends boolean = false>(
  options?: Options<ComposerListEscalationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ComposerListEscalationsResponses, unknown, ThrowOnError>({
    url: "/composer/escalations",
    ...options,
  });

/**
 * Composer Translation Status
 *
 * Whether live translation is available, so the UI can say so honestly.
 */
export const composerTranslationStatus = <ThrowOnError extends boolean = false>(
  options?: Options<ComposerTranslationStatusData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ComposerTranslationStatusResponses, unknown, ThrowOnError>({
    url: "/composer/translation-status",
    ...options,
  });

/**
 * Health
 *
 * Return a simple health status payload.
 */
export const getHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetHealthData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetHealthResponses, unknown, ThrowOnError>({
    url: "/health",
    ...options,
  });

/**
 * Auth Signup
 *
 * Register a new user, already confirmed and ready to sign in.
 */
export const signup = <ThrowOnError extends boolean = false>(
  options: Options<SignupData, ThrowOnError>,
) =>
  (options.client ?? client).post<SignupResponses, SignupErrors, ThrowOnError>({
    url: "/auth/signup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Login
 *
 * Authenticate via Supabase, then set the signed session cookie.
 *
 * The Supabase access/refresh tokens never leave the backend — the browser
 * only ever sees the HMAC cookie this endpoint sets.
 */
export const login = <ThrowOnError extends boolean = false>(
  options: Options<LoginData, ThrowOnError>,
) =>
  (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    url: "/auth/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Logout
 *
 * Sign out — clear the session cookie.
 */
export const logout = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutData, ThrowOnError>,
) =>
  (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({
    url: "/auth/logout",
    ...options,
  });

/**
 * Auth Me
 *
 * Get the current user's profile.
 */
export const getMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetMeResponses, unknown, ThrowOnError>({
    url: "/auth/me",
    ...options,
  });

/**
 * Auth Me Detail
 *
 * Get the current user's profile with timeline fields.
 */
export const getMeDetail = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeDetailData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetMeDetailResponses, unknown, ThrowOnError>({
    url: "/auth/me/detail",
    ...options,
  });

/**
 * Auth Update Profile
 *
 * Update current user's name.
 */
export const updateProfile = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProfileData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError>({
    url: "/auth/profile",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Change Password
 *
 * Change the current user's password (verifies current password first).
 */
export const changePassword = <ThrowOnError extends boolean = false>(
  options: Options<ChangePasswordData, ThrowOnError>,
) =>
  (options.client ?? client).put<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    url: "/auth/password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Auth Activity
 *
 * Get the current user's activity log.
 */
export const getActivity = <ThrowOnError extends boolean = false>(
  options?: Options<GetActivityData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetActivityResponses, unknown, ThrowOnError>({
    url: "/auth/activity",
    ...options,
  });

/**
 * Admin List Users
 *
 * List all users (admin only).
 */
export const adminListUsers = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListUsersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AdminListUsersResponses, unknown, ThrowOnError>({
    url: "/admin/users",
    ...options,
  });

/**
 * Admin Delete User
 *
 * Delete a user (admin only). Self-deletion blocked.
 */
export const adminDeleteUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminDeleteUserData, ThrowOnError>,
) =>
  (options.client ?? client).delete<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
  });

/**
 * Admin Get User
 *
 * Get a single user detail with activity logs (admin only).
 */
export const adminGetUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminGetUserData, ThrowOnError>,
) =>
  (options.client ?? client).get<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
  });

/**
 * Admin Update User
 *
 * Update a user's name or role (admin only). Self-demotion blocked.
 */
export const adminUpdateUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminUpdateUserData, ThrowOnError>,
) =>
  (options.client ?? client).put<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin Block User
 *
 * Block a user's access (admin only). Self-blocking refused.
 */
export const adminBlockUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminBlockUserData, ThrowOnError>,
) =>
  (options.client ?? client).post<AdminBlockUserResponses, AdminBlockUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}/block",
    ...options,
  });

/**
 * Admin Unblock User
 *
 * Lift a block on a user (admin only).
 */
export const adminUnblockUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminUnblockUserData, ThrowOnError>,
) =>
  (options.client ?? client).post<AdminUnblockUserResponses, AdminUnblockUserErrors, ThrowOnError>({
    url: "/admin/users/{user_id}/unblock",
    ...options,
  });

/**
 * Admin Invite User
 *
 * Invite a user by email (admin only).
 */
export const adminInviteUser = <ThrowOnError extends boolean = false>(
  options: Options<AdminInviteUserData, ThrowOnError>,
) =>
  (options.client ?? client).post<AdminInviteUserResponses, AdminInviteUserErrors, ThrowOnError>({
    url: "/admin/invite",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Admin List Activity
 *
 * List activity across all users (admin only).
 *
 * Search, filtering, sorting, and pagination are all applied server-side by
 * the list_recent_activity RPC — the client sends params and renders results.
 */
export const adminListActivity = <ThrowOnError extends boolean = false>(
  options?: Options<AdminListActivityData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AdminListActivityResponses,
    AdminListActivityErrors,
    ThrowOnError
  >({ url: "/admin/activity", ...options });

/**
 * Admin Activity Analytics
 *
 * Aggregated activity analytics for the admin dashboard (admin only).
 */
export const adminActivityAnalytics = <ThrowOnError extends boolean = false>(
  options?: Options<AdminActivityAnalyticsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AdminActivityAnalyticsResponses,
    AdminActivityAnalyticsErrors,
    ThrowOnError
  >({ url: "/admin/activity/analytics", ...options });

/**
 * Admin Activity Actions
 *
 * Distinct activity actions across all time (admin only).
 *
 * Used to populate the activity filter dropdown so it matches the full,
 * unbounded table scope rather than the windowed analytics breakdown.
 */
export const adminActivityActions = <ThrowOnError extends boolean = false>(
  options?: Options<AdminActivityActionsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AdminActivityActionsResponses, unknown, ThrowOnError>({
    url: "/admin/activity/actions",
    ...options,
  });
